import $ from 'jquery';
import {Swiper, Navigation} from 'swiper/swiper.esm.js';
Swiper.use([Navigation]);


const swiper = new Swiper('.complex-swiper', {
    slidesPerView: 1,
    loop: true,
    navigation: {
        nextEl: '.complex-swiper-button-next',
        prevEl: '.complex-swiper-button-prev',
    }
});
